import React from 'react';
import {Link} from 'react-router-dom';

export default class LogoBox extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <div className="logo-box">
                    <Link to={`/`}>
                        <img src={publicUrl+"assets/images/resources/nazar_logo.png"} alt="Logo" />
                    </Link>
                </div>
            </>
        )
    }
}